// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__30FsG","icon":"styles_icon__2wPqo"};